import React, { ReactElement } from 'react';
import { PdsAlert } from "@principal/design-system-react";

export type AlertBannerProps = {
    message: string | ReactElement,
    children?: React.ReactNode
    variant?: "banner" | "error" | "information" | "success" | "warning",
    hideDismissButton?: boolean
}

const AlertBanner = (props: AlertBannerProps) => {
    const message = props.message;
    return (
        <PdsAlert variant={props.variant ?? 'error'} className="pds-u-margin-bottom-16" hideDismissButton={props.hideDismissButton}>
            {typeof message === 'string' ? <div>{message}</div> : message}
        </PdsAlert>
    )
};
export default AlertBanner;